import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import flower from '../../../static/images/flower.png'
import youreGoing from '../../../static/images/youre-going.png'

const { siteMetadata: config } = GatsbyConfig

export default class YoureGoing extends React.Component {
  render() {
    const { trip, name1, name2, heading, message } = this.props
    const tripData = config.trips[trip]

    return (
      <div
        style={{ backgroundImage: `url(/images/trip-slider-${trip}-wow.jpg)` }}
        className="youre-going"
      >
        <div className="wrap">
          <div className="youre-going-content">
            <h2>{heading || <img src={youreGoing} alt="You're Going!" />}</h2>
            <p>
              Aloha {name1} & {name2},
            </p>
            <p>
              {message}
              <span className="caps">
                {' '}
                LoveSong | {tripData.name} {tripData.year}!
              </span>
            </p>
          </div>
          <div className="youre-going-sidebar">
            <img src={flower} alt="" />
            <time>{tripData.dates}</time>
            <span className="caps">{tripData.location}</span>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/youre-going.js